module.exports = __webpack_public_path__ + "img/shield-cracked.e069054d.svg";